/**
 * Repository brand assets.
 *
 * Every mark comes from docs/design/brand, never a redrawn approximation and
 * never a typographic reconstruction: the wordmark used to be the string
 * "MATRIX" in a <strong>, which meant the brand changed shape depending on
 * whether a webfont had loaded and could not be checked against the sheet at
 * all (#3395).
 */

import type { TemplateInstance } from 'hydrogen/runtime';
import { html } from 'hydrogen/runtime';

/** Emitted by the build from docs/design/brand/. */
export const MATRIX_LOGO_SRC = '/brand/matrix-logo-5ccb6b53.svg';
export const MATRIX_WORDMARK_SRC = '/brand/matrix-wordmark-4efb73e9.svg';
export const MATRIX_LOCKUP_SRC = '/brand/matrix-lockup-b05ac670.svg';
export const MATRIX_MASCOT_SRC = '/brand/matrix-mascot-4fb9a209.svg';
/** Linked from index.html as the tab icon and the home-screen icon; the build rewrites them to their served names. */
export const MATRIX_FAVICON_SRC = '/brand/matrix-favicon-85acc0d5.svg';
export const MATRIX_TOUCH_ICON_SRC = '/brand/matrix-touch-icon-27bcd18e.png';

/** The angular M joined to the infinity ribbon. */
export function MatrixLogo(options: { className: string }): TemplateInstance {
  return html`<img class="${options.className}" src="${MATRIX_LOGO_SRC}" alt="" aria-hidden="true" width="682" height="666">`;
}

/** MATRIX as outlines. Decorative on its own; the lockup carries the name. */
export function MatrixWordmark(options: { className: string }): TemplateInstance {
  return html`<img class="${options.className}" src="${MATRIX_WORDMARK_SRC}" alt="" aria-hidden="true" width="5340" height="710">`;
}

/**
 * Mark and wordmark locked at the sheet's proportions. The one asset the
 * chrome consumes, so header, footer, and account pages cannot disagree about
 * the spacing between them.
 */
export function MatrixLockup(options: { className: string }): TemplateInstance {
  return html`<img class="${options.className}" src="${MATRIX_LOCKUP_SRC}" alt="" aria-hidden="true" width="528" height="100">`;
}

/** Batrix, the guardian of continuous change. Callers own sizing and alt text. */
export function MatrixBat(options: { className: string; alt: string }): TemplateInstance {
  return html`<img class="${options.className}" src="${MATRIX_MASCOT_SRC}" alt="${options.alt}" width="1224" height="1012">`;
}
